<template>
    <div>
        <h1>{{ settingObj.name }} : Liste des dictionnaires orthographiques</h1>
        <div class="pl-list dictionaries_area">
		    <div class="header">
		        <div class="header_line">
                    <div id="header_col1" class="header_col col1">Nom</div>
                    <div id="header_col2" class="header_col col2">Installé</div>
	    	    </div>
		    </div>
        
            <div class="content">

                <dicoLine v-for="(dico) in dicos" :key='dico.name' :dicoObj='dico' :settingObj='settingObj' ></dicoLine>
            
            </div>
		    <div class="footer">
		        <div class="buttons">
		            <button id="btn_add" type="button" class="liste_btn boutonTableau" title="Créer un dictionnaire" @click='clickBtnAdd()'>Créer</button>
		        </div>
		    </div>
        </div>

        <br/>
        <div id="warning">
            <i id="warning_icon" class="material-icons">warning_amber</i>
            <span id="warning_txt"> Tout changement dans cette page sera effectif <u>15 minutes</u> après avoir cliqué sur "Envoyer les modifs" en haut à droite.</span>
        </div>
    </div>
</template>

<script>
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import DicoLine from '@/components/DicoLine';

    export default { 
        name:"Dicos",
        components:{
            "dicoLine":DicoLine,
        },
        mixins: [FctUtils],
        props:{
            settingProps: {type:String}, // arrive depuis un push -> String
        },
        data(){
            return {
                settingObj: {},
                dicos:{}
            }
        },
        created() {
            // Si pas de settings, on regarde s'il n'y en a pas un deja dans le store
            if (!FctUtils.methods.noEmpty(this.settingProps)) {
                this.settingObj = this.$store.getters.setting;
            }
            else {
                this.settingObj = JSON.parse(this.settingProps);
            }

            // Si Setting Ok, on affiche les dicos correspondants
            if (FctUtils.methods.noEmpty(this.settingObj)) {
                // Recup les dicos associées aux settingID
                axios.get(diagonalbackURL + "/settings/"+this.settingObj.id+"/dictionaries", defaultConfig)
                    .then(reponse => {
                        this.dicos = reponse.data;
                    })
                    .catch(error => this.errorHandler(error));
            }
            else {
                // si toujours pas de setting, on retourne vers la selection de la configuration
                this.$router.push({name:"SelectDicoSetting", 
                    params: {
                        from: "Dicos"
                    }
                });
            }
        },
        mounted() {
            this.emitter.on('createDico', newDicoData => {
                this.createDico(newDicoData)
            });
            this.emitter.on('removeDico', aDicoToDelData => {
                this.removeDico(aDicoToDelData)
            });
        },
        unmounted() {
            this.emitter.off('createDico');
            this.emitter.off('removeDico');
        },
        methods : {
            clickBtnAdd() {
                this.emitter.emit('showPLForm', {mode: 'formDico_new'});
            },
            // Création du dictionnaire.
            //
            createDico(aNewDicoData) {
                console.log("Creation du dictionnaire : " + aNewDicoData.name)

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/dictionaries/" + aNewDicoData.name);

                axios.put(url, null, defaultConfig)
                .then(reponse => {
                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            // Suppression d'un dictionnaire.
            //
            removeDico(toDelDico) {
                console.log("Suppression du dictionnaire : "+toDelDico.name)

                var url = encodeURI(diagonalbackURL + "/settings/"+this.settingObj.id+"/dictionaries/" + toDelDico.name);

                axios.delete(url,  defaultConfig)
                .then(reponse => {
                    if ((reponse.status == '400') && (typeof reponse.responseJSON.error !== "undefined") && (iJqXHR.responseJSON.error == 'InstalledDico') ) {
                        alert('Le dictionnaire '+ toDelDico.name +' doit être désinstallé avant sa suppression.')
                    }
                    else if((reponse.status == '400')) {
                        alert('Echec lors de la suppression du dictionnaire');
                    }
                    else {
                        //alert('Suppression du dictionnaire : ' + toDelDico.name);
                        this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                        this.$router.go();
                    }
                })
                .catch(error => this.errorHandler(error));
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



.pl-list.dictionaries_area .line {
    width: 100%;
    position: relative;
}


</style>
